export const languages = {
  en: {
    About: "About",
    Portfolio: "Portfolio",
    Services: "Services",
    HireUs: "Hire us",

    HeroStrong: "OUR COMPANY",
    HeroHeader:
      "DOES ROOFING REPAIRS AND CONSTRUCTION OF A BUILDING'S INTERIORS",
    HeroButton: "Explore our work",

    Mission: "Mission",
    Competence: "Competence",
    Experience: "Experience",

    OurMission: "Our Mission",
    OurCompetence: "Our Competence",
    OurExperience: "Our Experience",

    OurMissionHeader: "WE CARE ABOUT THE DETAILS AND QUALITY. ALWAYS.",
    OurCompetenceHeader: "WE ONLY DO WHAT WE PERFECTLY MASTERED. ALWAYS.",
    OurExperienceHeader: "WE RELY ON OUR EXPERIENCE AND SKILLS. ALWAYS.",

    OurMissionText:
      "Our mission is to deliver the best construction services with high performance quality within the shortest period. We believe in productive cooperation with our clients in order to obtain the best possible results.",

    OurCompetenceText:
      "Our company does roofing repairing of various materials. We produce waterproofing coatings designed for sealing and repairing roofs. We also provide services for full house construction or the interior construction.",

    OurExperienceText:
      "Our skills and experience allow us quickly and efficiently perform a wide variety of services. It is valuable for us to complete the project on high quality level. We do all our best, so that project meets all the requirements of our customer.",

    OurWorks: "Our Works",

    Project1: "Project Zelenki",
    Project1Tags: ["construction", "roof installation"],
    Project1Text:
      "We carried out the installation of fireplaces and roofs. We also laid tiles and installed a drainage system.",

    Project2: "Project ul.Szlak",
    Project2Tags: ["waterproofing", "roof repairs"],
    Project2Text:
      "In this project we have made the roof and the drains waterproof.",

    Project3: "Project ul.Mierickiego",
    Project3Tags: ["waterproofing", "roof insulation"],
    Project3Text:
      "Roof insulation with polystyrene foam, roofing material laying, replacement of ventilation pipes, installation of attic exit, waterproofing cover of the entire roof.",

    Project4: "Project Niepolomice",
    Project4Tags: ["waterproofing", "roof repairs"],
    Project4Text:
      "In this project we have waterproofed the roof and the drains.",

    Project5: "Project AGH",
    Project5Tags: ["waterproofing", "pipe installation"],
    Project5Text:
      "We completed waterproofing of the roof and installed ventilation pipes.",

    Service1Header: "RENOVATION AND CONSTRUCTION OF ROOFS",
    Service1Text:
      "We produce waterproofing coatings designed for sealing and repairing roofs.",

    Service2Header: "REPLACEMENT OF DRAINS AND METAL FACING OF FIREPLACES.",
    Service2Text:
      "The problem with a drain starts silently. We solve it quickly and efficiently.",

    Service3Header: "INSULATION OF ROOFS AND HOUSES",
    Service3Text:
      "We insulate houses and roofs with the use of foam, mineral wool, followed by the application of plaster.s",

    Service4Header: "INTERIOR CONSTRUCTION",
    Service4Text:
      "Floor laying, installation of plasterboard piers, installation of plumbing, tile laying, installation of lamps.",

    ContactInfoHeader: "CONTACT INFORMATION",
    ContactInfoText:
      "Fill in the form with your contact details and we will reach out to you within 24 hours.",

    FormName: "Name",
    FormEmail: "Email",
    FormMessage: "Message",
    FormButton: "Send",
    FormFeedback: "Your message has been sent",
  },
  pl: {
    About: "O nas",
    Portfolio: "Portfolio",
    Services: "Oferta",
    HireUs: "Kontakt",

    HeroStrong: "Nasza firma",
    HeroHeader: "wykonuje remonty pokryć dachowych oraz wykończenia wnętrz ",
    HeroButton: "Zobacz więcej",

    Mission: "Misja",
    Competence: "Komptenecja",
    Experience: "Doświadczenie",

    OurMission: "Nasza misja",
    OurCompetence: "Nasze kompetencje",
    OurExperience: "Nasze doświadczenie",

    OurMissionHeader: "Dbamy o szczegóły i jakość. Zawsze.",
    OurCompetenceHeader: "Robimy tylko to, co doskonale opanowaliśmy. Zawsze.",
    OurExperienceHeader:
      "Polegamy na naszym doświadczeniu i umiejętnościach. Zawsze.",

    OurMissionText:
      "Naszą misją jest dostarczanie najlepszych usług budowlanych o wysokiej jakości wykonania w jak najkrótszym czasie. Wierzymy w mocną współpracę z naszymi klientami w celu uzyskania jak najlepszych rezultatów.",

    OurCompetenceText:
      "Nasza firma zajmuje się naprawą pokryć dachowych z różnych materiałów. Produkujemy powłoki hydroizolacyjne przeznaczone do uszczelniania i naprawy dachów. Świadczymy również usługi w zakresie budowy domów jednorodzinnych oraz  wykończenia wnętrz.",

    OurExperienceText:
      "Nasze umiejętności i doświadczenie pozwalają nam szybko i skutecznie wykonywać szeroki zakres usług. Bardzo ważne jest dla nas ukończenie projektu na wysokim poziomie jakości . Dokładamy wszelkich starań, aby projekt spełniał wszystkie wymagania naszego klienta.",

    OurWorks: "Nasze projekty",

    Project1: "Projekt Zelenki",
    Project1Tags: ["remont domu", "pokrycie dachu"],
    Project1Text:
      "Wykonaliśmy układanie kominków i montaż dachu, również układanie płytek, instalację techniczną wyjścia wraz z systemem odpływowym.",

    Project2: "Projekt ul.Szlak",
    Project2Tags: ["Hydroizolacja", "naprawa dachu"],
    Project2Text: "W tym projekcie wykonaliśmy hydroizolację dachu i rynn.",

    Project3: "Projekt ul. Mierickiego",
    Project3Tags: ["hydroizolacja", "ocieplenie dachu"],
    Project3Text:
      "Ocieplenie dachu styropianem, układanie papy, wymiana rur wentylacyjnych, montaż wylotu poddasza, hydroizolacja całego dachu.",

    Project4: "Projekt Niepolomice",
    Project4Tags: ["hydroizolacja", "pokrycie dachu"],
    Project4Text: "W tym projekcie wykonaliśmy hydroizolację dachu i rynn.",

    Project5: "Project AGH",
    Project5Tags: ["hydroizolacja", "montaż rur"],
    Project5Text:
      "Wykonaliśmy pełną hydroizolację dachu i zainstalowaliśmy rury wentylacyjne.",

    Service1Header: "Remonty starych dachów i wykonanie nowych",
    Service1Text:
      "Wykonujemy powłoki hydroizolacyjne przeznaczone do uszczelniania i naprawy pokryć dachowych.",

    Service2Header: "Wymiana odpływów i odbudowy kominków",
    Service2Text:
      "Problem z zatkanym odpływem zaczyna się niewinnie. Szybko i skutecznie go rozwiązujemy.",

    Service3Header: "Ocieplenia dachów i domów",
    Service3Text:
      "Izolujemy domy i dachy za pomocą styropianu, wełny mineralnej, a następnie nakładamy tynk dekoracyjny.",

    Service4Header: "Wykończenia wnętrz",
    Service4Text:
      "Układanie podłóg, montaż płyt gipsowo-kartonowych, montaż instalacji wodno-kanalizacyjnych, układanie płytek, montaż lamp.",

    ContactInfoHeader: "Skontaktuj się z nami",
    ContactInfoText:
      "Wypełnij formularz, a my skontaktujemy się z Tobą w ciągu 24 godzin.",

    FormName: "Imię",
    FormEmail: "Email",
    FormMessage: "Wiadomość",
    FormButton: "Wyślij",
    FormFeedback: "Twoja wiadmość została wysłana",
  },
  ru: {
    About: "О нас",
    Portfolio: "Портфолио",
    Services: "Услуги",
    HireUs: "Связаться",

    HeroStrong: "Наша компания",
    HeroHeader: "осуществляет ремонтные работы крыш и внутреннею отделку домов",
    HeroButton: "Наши работы",

    Mission: "Миссия",
    Competence: "Специализация",
    Experience: "Опыт",

    OurMission: "Наша миссия",
    OurCompetence: "Наша специализация",
    OurExperience: "Наш Опыт",

    OurMissionHeader: "Мы заботимся о деталях и качестве. Всегда.",
    OurCompetenceHeader:
      "Мы делаем только то, что в совершенстве освоили. Всегда.",
    OurExperienceHeader: "Мы полагаемся на наш опыт и навыки. Всегда.",

    OurMissionText:
      "Наша миссия состоит в том, чтобы предоставить лучшие строительные услуги с высоким качеством исполнения в кратчайшие сроки. Мы верим в продуктивное сотрудничество с нашими клиентами с целью получения наилучших результатов.",
    OurCompetenceText:
      "Наша фирма осуществляет ремонты крыш из различных материалов. Изготавливаем гидроизоляционные покрытия, предназначенные для герметизации и ремонта существующей кровли. Мы также предоставляем услуги по строительству дома в целом и его внутренней отделке.",
    OurExperienceText:
      "Наши навыки и опыт позволяют нам быстро и эффективно выполнять широкий спектр услуг. Для нас очень важно завершить проект на высоком уровне качества . Мы делаем все возможное, чтобы проект отвечал всем требованиям нашего заказчика.",

    OurWorks: "Наши проекты",

    Project1: "Проект Zelenki",
    Project1Tags: ["ремонт дома", "установка крыши"],
    Project1Text:
      "Осуществили укладку каминов и установку крыши. Также выполнили укладку черепицы, установку тех. выхода вместе с системой сливов и стоков.",

    Project2: "Проект ul.Szlak",
    Project2Tags: ["гидроизоляция", "ремонт крыши"],
    Project2Text:
      "В данном проекте мы осуществили гидроизоляция крыши и сливов.",

    Project3: "Проект ul.Mierickiego",
    Project3Tags: ["гидроизоляция", " утепление крыши"],
    Project3Text:
      "Утепление крыши пено полистиролом, укладка рубероида, замена вентиляционных труб, установка чердачного выхода, гидроизоляция всей крыши.",

    Project4: "Проект Niepolomice",
    Project4Tags: ["гидроизоляция", "покрытие крыши"],
    Project4Text: "В этом проекте мы осуществили гидроизоляцию крыши и сливов.",

    Project5: "Проект AGH",
    Project5Tags: ["гидроизоляция", "установка труб"],
    Project5Text:
      "Осуществили полную гидроизоляция крыши, а также установили вентиляционные трубы.",

    Service1Header: "Реновация старых и изготовление новых крыш",
    Service1Text:
      "Изготавливаем гидроизоляционные покрытия, предназначенные для герметизации и ремонта кровли.",

    Service2Header: "Замена сливов и металлической облицовки каминов.",
    Service2Text:
      "Проблема с забитым стоком начинается незаметно. Мы решаем ее быстро и эффективно.",

    Service3Header: "Утепление крыш и дома",
    Service3Text:
      "Утепляем с применением пенопласта, минеральной ваты, с последующим нанесением декоративной штукатурки.",

    Service4Header: "Внутренние работы",
    Service4Text:
      "Укладка пола, установка гипсокартонных простенков, установка сантехники, укладка кафеля, установка светильников, покраска.",

    ContactInfoHeader: "Свяжитесь с нами",
    ContactInfoText:
      "Заполните форму с вашими контактными данными и мы свяжемся с вами в течении 24 часов.",

    FormName: "Имя",
    FormEmail: "Email",
    FormMessage: "Сообщение",
    FormButton: "Отправить",
    FormFeedback: "Ваше сообщение было отправлено",
  },
  uk: {
    About: "Про нас",
    Portfolio: "Портфоліо",
    Services: "Послуги",
    HireUs: "Зв'язатися",

    HeroStrong: "Наша компанія",
    HeroHeader: "здійснює ремонтні роботи дахів і внутрішню обробку будинків",
    HeroButton: "Наші роботи",

    Mission: "Місія",
    Competence: "Спеціалізація",
    Experience: "Досвід",

    OurMission: "Наша місія",
    OurCompetence: "Наша спеціалізація",
    OurExperience: "Наш досвід",

    OurMissionHeader: "Ми дбаємо про деталі і якість. Завжди.",
    OurCompetenceHeader: "Ми робимо тільки те, що досконало освоїли. Завжди.",
    OurExperienceHeader: "Ми покладаємося на наш досвід і навички. Завжди.",

    OurMissionText:
      "Наша місія полягає в тому, щоб надати кращі будівельні послуги з високою якістю виконання в найкоротші терміни. Ми віримо в продуктивну співпрацю з нашими клієнтами з метою отримання найкращих результатів.",
    OurCompetenceText:
      "Наша фірма здійснює ремонти дахів з різних матеріалів. Виготовляємо гідроізоляційні покриття, призначені для герметизації і ремонту існуючої покрівлі. Ми також надаємо послуги з будівництва будинку в цілому і його внутрішнього оздоблення.",
    OurExperienceText:
      "Наші навички і досвід дозволяють нам швидко і ефективно виконувати широкий спектр послуг. Для нас дуже важливо завершити проект на високому рівні якості. Ми робимо все можливе, щоб проект відповідав всім вимогам нашого замовника.",

    OurWorks: "Наші проекти",

    Project1: "Проект Zelenki",
    Project1Tags: ["ремонт будинку", "установка даху"],
    Project1Text:
      "Здійснили укладання камінів і установку даху. Також виконали укладання черепиці, установку тех. виходу разом з системою зливів і стоків.",

    Project2: "Проект ul.Szlak",
    Project2Tags: ["гідроізоляція", "ремонт даху"],
    Project2Text: "В даному проекті ми здійснили гідроізоляція даху і зливів.",

    Project3: "Проект ul.Mierickiego",
    Project3Tags: ["гідроізоляція", " утеплення даху"],
    Project3Text:
      "Утеплення даху піно полістиролом, укладання руберойду, заміна вентиляційних труб, установка горищного виходу, гідроізоляція всього даху.",

    Project4: "Проект Niepolomice",
    Project4Tags: ["гідроізоляція", "покриття даху"],
    Project4Text: "У цьому проекті ми здійснили гідроізоляцію даху і зливів.",

    Project5: "Проект AGH",
    Project5Tags: ["гідроізоляція", "установка труб"],
    Project5Text:
      "Здійснили повну гідроізоляція даху, а також встановили вентиляційні труби.",

    Service1Header: "Реновація старих і виготовлення нових дахів",
    Service1Text:
      "Виготовляємо гідроізоляційні покриття, призначені для герметизації і ремонту покрівлі.",

    Service2Header: "Заміна зливів і металевого облицювання камінів.",
    Service2Text:
      "Проблема із забитим стоком починається непомітно. Ми вирішуємо її швидко і ефективно.",

    Service3Header: "Утеплення дахів і будинків",
    Service3Text:
      "Утеплюємо із застосуванням пінопласту, мінеральної вати, з подальшим нанесенням декоративної штукатурки.",

    Service4Header: "Внутрішні роботи",
    Service4Text:
      "Укладання підлоги, установка гіпсокартонних простінків, установка сантехніки, укладання кахлю, установка світильників, фарбування.",

    ContactInfoHeader: "Зв'яжіться з нами",
    ContactInfoText:
      "Заповніть форму з вашими контактними даними і ми зв'яжемося з вами протягом 24 годин.",

    FormName: "Ім'я",
    FormEmail: "Email",
    FormMessage: "Повідомлення",
    FormButton: "Відправити",
    FormFeedback: "Ваше повідомлення було відправлено",
  },
};
// export default languages;
